<div class="event-edit">
  <rappider-crud-view-edit-form [data]="workflowEvent"
                                [config]="WORKFLOW_EVENT_EDIT_CONFIG"
                                [submitButtonLoading]="submitButtonLoading"
                                [cancelButtonLoading]="cancelButtonLoading"
                                (fieldValueChange)="onFieldValueChange($event)"
                                (formSubmit)="onEditWorkflowEventFormSubmit($event)"
                                (cancelButtonConfirmClick)="onDeleteEvent()"></rappider-crud-view-edit-form>
  <section>
    <rappider-heading [content]="workflowEventDeleteAllWorkflowConfig.content"
                      type="h6"></rappider-heading>
    <rappider-button [colorType]="workflowEventDeleteAllWorkflowConfig.colorType"
                     [text]="workflowEventDeleteAllWorkflowConfig.text"
                     [popconfirmTitle]="workflowEventDeleteAllWorkflowConfig.popconfirmTitle"
                     [emitWithoutPopconfirm]="workflowEventDeleteAllWorkflowConfig.emitWithoutPopconfirm"
                     [popconfirmCancelText]="workflowEventDeleteAllWorkflowConfig.popconfirmCancelText"
                     [popconfirmOkText]="workflowEventDeleteAllWorkflowConfig.popconfirmOkText"
                     [popconfirmOkDanger]="workflowEventDeleteAllWorkflowConfig.popconfirmOkDanger"
                     (confirm)="onDeleteWorkflowEvent()"></rappider-button>
  </section>
</div>
